import { Box, Typography } from "@mui/material";
import { useDeleteLicenseMutation } from "Api/Mutations/Licenses/useDeleteLicenseMutation";
import { Colors } from "Components/Layout/Themes/Colors";
import { UnstyledButton } from "Components/Shared/Buttons/UnstyledButton";
import { TransactionPaymentOptions } from "Components/Transactions/TransactionPaymentOptions";
import { Resources, useResource } from "Translations/Resources";
import { toast } from "sonner";

const ComponentResources = Resources.Pages.Content.LicenseDetail;

type Props = {
  transactionPublicID: string;
  licensePublicID: string;
};

export const LicenseOrderActions = ({
  transactionPublicID,
  licensePublicID,
}: Props) => {
  const { t } = useResource();
  const { mutate: deleteLicense, isPending } = useDeleteLicenseMutation();

  return (
    <Box display="flex" flexDirection="column" gap={5}>
      <Typography color={Colors.Red}>
        {t(ComponentResources.PaymentPendingInfo)}
        <UnstyledButton
          onClick={() =>
            window.confirm(t(ComponentResources.CancelOrderConfirmation)) &&
            deleteLicense(licensePublicID, {
              onError: () => toast.error(t(Resources.Errors.RequestError)),
            })
          }
          sx={{
            ml: 1,
            color: Colors.Red,
            display: "inline-block",
            textDecoration: "underline",
          }}
        >
          {t(ComponentResources.CancelOrder)}
        </UnstyledButton>
      </Typography>
      <TransactionPaymentOptions
        isDirectPaymentHidden
        transactionPublicID={transactionPublicID}
        isDisabled={isPending}
      />
    </Box>
  );
};
